/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetSavingsActiveInputsRequest} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'
import {GetSavingsActiveInputsResponse} from '@cash-web/protos/squareup/cash/piggybank/api/v2/piggybank_service.pb'


export const getSavingsActiveInputs = (request: GetSavingsActiveInputsRequest, options?: CashRequestOptions) => post<GetSavingsActiveInputsRequest, GetSavingsActiveInputsResponse>("/2.0/cash/get-savings-active-inputs", request, {...options, rejectOnError: true })